<template>
    <div id="ob-blooms" aria-hidden="true">
        <div class="bloom bloom-1" />
        <div class="bloom bloom-2" />
        <div class="bloom bloom-3" />
        <div class="bloom bloom-4" />
        <div class="bloom bloom-5" />
        <div class="bloom bloom-6" />
    </div>
</template>

<style scoped>
    #ob-blooms {
        position: fixed;
        inset: -18vh -12vw;
        z-index: 0;
        pointer-events: none;
    }
    .bloom { position: absolute; border-radius: 50%; will-change: transform; transform: translateZ(0); }

    /* Mobile GPUs choke on six huge 80–95px blurs — keep three, soften them. */
    @media (max-width: 900px) {
        .bloom { filter: blur(56px) !important; animation: none !important; }
        .bloom-4, .bloom-5, .bloom-6 { display: none; }
    }
    .bloom-1 {
        top: -8%; left: 0%; width: 54vw; height: 54vw;
        background: radial-gradient(circle, rgba(39, 169, 225, .72), transparent 64%);
        filter: blur(80px);
        animation: bloom1 24s ease-in-out infinite, softpulse 11s ease-in-out infinite;
    }
    .bloom-2 {
        top: 12%; right: -6%; width: 48vw; height: 48vw;
        background: radial-gradient(circle, rgba(0, 113, 187, .6), transparent 66%);
        filter: blur(90px);
        animation: bloom2 29s ease-in-out infinite;
    }
    .bloom-3 {
        top: 50%; left: -8%; width: 46vw; height: 46vw;
        background: radial-gradient(circle, rgba(237, 38, 116, .26), transparent 66%);
        filter: blur(95px);
        animation: bloom3 27s ease-in-out infinite;
    }
    .bloom-4 {
        top: 86%; right: -4%; width: 50vw; height: 50vw;
        background: radial-gradient(circle, rgba(39, 169, 225, .66), transparent 64%);
        filter: blur(90px);
        animation: bloom1 31s ease-in-out infinite;
    }
    .bloom-5 {
        top: 128%; left: 2%; width: 46vw; height: 46vw;
        background: radial-gradient(circle, rgba(0, 113, 187, .58), transparent 66%);
        filter: blur(95px);
        animation: bloom2 26s ease-in-out infinite;
    }
    .bloom-6 {
        top: 170%; right: 0%; width: 48vw; height: 48vw;
        background: radial-gradient(circle, rgba(39, 169, 225, .6), transparent 66%);
        filter: blur(95px);
        animation: bloom3 28s ease-in-out infinite;
    }
</style>
